import EnvironmentManager from 'Utils/environmentManager';

export function updateMbsBackgroundColors () {
  const root = document.documentElement;
  
  const colourMbs1 = EnvironmentManager.getMessageText({
    key: 'colour_mbs1',
  });
  const colourMbs2 = EnvironmentManager.getMessageText({
    key: 'colour_mbs2',
  });
  const colourMbs3 = EnvironmentManager.getMessageText({
    key: 'colour_mbs3',
  });
  const colourMbs4 = EnvironmentManager.getMessageText({
    key: 'colour_mbs4',
  });
  
  root.style.setProperty('--mbs-1-background', `${colourMbs1}`);
  root.style.setProperty('--mbs-2-background', `${colourMbs2}`);
  root.style.setProperty('--mbs-3-background', `${colourMbs3}`);
  root.style.setProperty('--mbs-4-background', `${colourMbs4}`);
}
